// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 12px 20px;
}
.card .card-header h5 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}
.card .card-body {
  padding: 20px;
}

.badge {
  padding: 6px 12px;
  font-size: 0.875rem;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.badge mat-icon {
  font-size: 14px;
  height: 14px;
  width: 14px;
}

.badge-primary {
  background-color: #007bff;
  color: white;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-danger {
  background-color: #dc3545;
  color: white;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.table-responsive {
  overflow-x: auto;
}

.table {
  margin-bottom: 0;
}
.table thead th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  padding: 12px;
  white-space: nowrap;
}
.table thead tr.filter-row th {
  background-color: #ffffff;
  border-bottom: 1px solid #dee2e6;
  padding: 8px;
}
.table thead tr.filter-row th input, .table thead tr.filter-row th select {
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
}
.table thead tr.filter-row th input:focus, .table thead tr.filter-row th select:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.table thead tr.filter-row th button {
  padding: 4px 8px;
}
.table thead tr.filter-row th button mat-icon {
  margin: 0;
}
.table tbody tr:hover {
  background-color: #f8f9fa;
}
.table tbody tr td {
  padding: 12px;
  vertical-align: middle;
}

.alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}
.alert mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
}

.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.alert-info {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  color: #0c5460;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s;
}
.btn mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}
.btn-primary:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}

.btn-sm {
  padding: 4px 8px;
  font-size: 0.8rem;
}

.btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}
.btn-danger:hover {
  background-color: #c82333;
  border-color: #bd2130;
}

.text-muted {
  color: #6c757d;
}

.text-danger {
  color: #dc3545;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/cmdb-sync/sync-item-logs.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;AACE;EACE,yBAAA;EACA,gCAAA;EACA,kBAAA;AACJ;AACI;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;AACN;AAGE;EACE,aAAA;AADJ;;AAKA;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAFF;AAIE;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAFJ;;AAMA;EACE,yBAAA;EACA,YAAA;AAHF;;AAMA;EACE,yBAAA;EACA,YAAA;AAHF;;AAMA;EACE,yBAAA;EACA,YAAA;AAHF;;AAMA;EACE,yBAAA;EACA,cAAA;AAHF;;AAMA;EACE,yBAAA;EACA,YAAA;AAHF;;AAMA;EACE,yBAAA;EACA,YAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;AAKE;EACE,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAHJ;AAME;EACE,yBAAA;EACA,gCAAA;EACA,YAAA;AAJJ;AAMI;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAJN;AAMM;EACE,aAAA;EACA,qBAAA;EACA,gDAAA;AAJR;AAQI;EACE,gBAAA;AANN;AAQM;EACE,SAAA;AANR;AAYI;EACE,yBAAA;AAVN;AAaI;EACE,aAAA;EACA,sBAAA;AAXN;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAbF;AAeE;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAbJ;;AAiBA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AAdF;AAgBE;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAdJ;;AAkBA;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;AAfF;AAiBE;EACE,yBAAA;EACA,qBAAA;AAfJ;;AAmBA;EACE,gBAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;AAhBF;AAkBE;EACE,yBAAA;EACA,qBAAA;AAhBJ;;AAoBA;EACE,cAAA;AAjBF;;AAoBA;EACE,cAAA;AAjBF","sourcesContent":[".card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n\n  .card-header {\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n    padding: 12px 20px;\n\n    h5 {\n      margin: 0;\n      font-size: 1.1rem;\n      font-weight: 600;\n    }\n  }\n\n  .card-body {\n    padding: 20px;\n  }\n}\n\n.badge {\n  padding: 6px 12px;\n  font-size: 0.875rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n\n  mat-icon {\n    font-size: 14px;\n    height: 14px;\n    width: 14px;\n  }\n}\n\n.badge-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.badge-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.badge-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.badge-warning {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.badge-info {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n.table {\n  margin-bottom: 0;\n\n  thead th {\n    background-color: #f8f9fa;\n    border-bottom: 2px solid #dee2e6;\n    font-weight: 600;\n    padding: 12px;\n    white-space: nowrap;\n  }\n\n  thead tr.filter-row th {\n    background-color: #ffffff;\n    border-bottom: 1px solid #dee2e6;\n    padding: 8px;\n\n    input, select {\n      width: 100%;\n      padding: 4px 8px;\n      border: 1px solid #ced4da;\n      border-radius: 4px;\n      font-size: 0.875rem;\n\n      &:focus {\n        outline: none;\n        border-color: #80bdff;\n        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n      }\n    }\n\n    button {\n      padding: 4px 8px;\n\n      mat-icon {\n        margin: 0;\n      }\n    }\n  }\n\n  tbody tr {\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    td {\n      padding: 12px;\n      vertical-align: middle;\n    }\n  }\n}\n\n.alert {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n\n  mat-icon {\n    font-size: 20px;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.alert-danger {\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n.alert-info {\n  background-color: #d1ecf1;\n  border: 1px solid #bee5eb;\n  color: #0c5460;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: all 0.2s;\n\n  mat-icon {\n    font-size: 18px;\n    height: 18px;\n    width: 18px;\n  }\n}\n\n.btn-primary {\n  background-color: #007bff;\n  border-color: #007bff;\n  color: white;\n\n  &:hover {\n    background-color: #0069d9;\n    border-color: #0062cc;\n  }\n}\n\n.btn-sm {\n  padding: 4px 8px;\n  font-size: 0.8rem;\n}\n\n.btn-danger {\n  background-color: #dc3545;\n  border-color: #dc3545;\n  color: white;\n\n  &:hover {\n    background-color: #c82333;\n    border-color: #bd2130;\n  }\n}\n\n.text-muted {\n  color: #6c757d;\n}\n\n.text-danger {\n  color: #dc3545;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
